import { useId, useState } from "react";

const METAL = {
  1: { hi: "#FFF1B8", mid: "#E2B93B", lo: "#8A6410", edge: "#5C420A", text: "#6B4D0C" },
  2: { hi: "#FFFFFF", mid: "#C9CDD3", lo: "#767C85", edge: "#4A4F57", text: "#5A6068" },
  3: { hi: "#F6CBA2", mid: "#CD7F32", lo: "#7A4414", edge: "#4F2B0C", text: "#5E3310" },
};

/* Metallic medal with red ribbon + laurel. Centre shows the member avatar when it
 * exists and loads; otherwise the embossed position numeral. viewBox 120x150. */
export default function Medal({ position, avatarUrl, alt = "", size = 120, testId }) {
  const m = METAL[position] || METAL[1];
  const [failed, setFailed] = useState(false);
  const showAvatar = Boolean(avatarUrl) && !failed;
  const id = `medal-${position}-${useId().replace(/:/g, "")}`;
  const leaves = Array.from({ length: 7 }, (_, i) => -62 + i * 20);
  return (
    <svg viewBox="0 0 120 150" width={size} height={size * 1.25} className="block select-none" aria-hidden="true" data-testid={testId} data-medal-mode={showAvatar ? "avatar" : "numeral"}>
      <defs>
        <linearGradient id={`${id}-ribbon`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#E0202E" /><stop offset="1" stopColor="#8E0B1A" />
        </linearGradient>
        <radialGradient id={`${id}-rim`} cx="35%" cy="30%" r="80%">
          <stop offset="0" stopColor={m.hi} /><stop offset="0.45" stopColor={m.mid} /><stop offset="1" stopColor={m.lo} />
        </radialGradient>
        <radialGradient id={`${id}-face`} cx="50%" cy="40%" r="70%">
          <stop offset="0" stopColor={m.mid} /><stop offset="1" stopColor={m.lo} />
        </radialGradient>
        <clipPath id={`${id}-clip`}><circle cx="60" cy="98" r="27" /></clipPath>
      </defs>
      {/* ribbon */}
      <path d="M30 2 L58 2 L66 64 L44 70 Z" fill={`url(#${id}-ribbon)`} />
      <path d="M90 2 L62 2 L54 64 L76 70 Z" fill={`url(#${id}-ribbon)`} opacity="0.92" />
      <path d="M44 2 L46 2 L58 66 L54 67 Z" fill="#FF6B73" opacity="0.35" />
      {/* medal disc */}
      <circle cx="60" cy="98" r="45" fill={m.edge} />
      <circle cx="60" cy="97" r="44" fill={`url(#${id}-rim)`} />
      <circle cx="60" cy="97" r="37" fill="none" stroke={m.edge} strokeWidth="1.2" opacity="0.8" />
      <circle cx="60" cy="98" r="36" fill={`url(#${id}-face)`} />
      {/* laurel */}
      <g fill={m.hi} opacity="0.8">
        {leaves.map((a) => (
          <g key={`l${a}`} transform={`rotate(${a - 180} 60 98)`}><ellipse cx="60" cy="59" rx="2.4" ry="5.5" transform="rotate(-18 60 59)" /></g>
        ))}
        {leaves.map((a) => (
          <g key={`r${a}`} transform={`rotate(${180 - a} 60 98)`}><ellipse cx="60" cy="59" rx="2.4" ry="5.5" transform="rotate(18 60 59)" /></g>
        ))}
      </g>
      {showAvatar ? (
        <>
          <image href={avatarUrl} x="33" y="71" width="54" height="54" preserveAspectRatio="xMidYMid slice" clipPath={`url(#${id}-clip)`} onError={() => setFailed(true)} />
          <circle cx="60" cy="98" r="27" fill="none" stroke={m.hi} strokeWidth="1.5" />
          <title>{alt}</title>
        </>
      ) : (
        <text x="60" y="113" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontWeight="700" fontSize="42" fill={m.text} stroke={m.hi} strokeWidth="0.8" paintOrder="stroke">{position}</text>
      )}
      <ellipse cx="46" cy="76" rx="14" ry="6" fill="#fff" opacity="0.14" transform="rotate(-30 46 76)" />
    </svg>
  );
}
